export default "__VITE_ASSET__376c1fd1__"